import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';
import util from 'preact-util';

import { KEY_TYPES } from '../../lib/clubOps';

function initialState({ isNew, clubKey }) {
    const k = (!isNew && clubKey) || {};
    return {
        holder: !isNew && k.holder ? { id: k.holder, firstname: k.holderName || '', lastname: '' } : null,
        memberSearch: '',
        members: [],
        label: k.label || '',
        keyType: k.keyType || 'key',
        number: k.number || '',
        note: k.note || '',
        error: '',
        isSaving: false,
    };
}

@observer
class ClubOpsKeyDrawer extends Component {
    constructor(props) {
        super(props);
        this.state = initialState(props);
        this.searchTimer = null;
    }

    componentWillUnmount() {
        if (this.searchTimer) {
            clearTimeout(this.searchTimer);
        }
    }

    onField = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value, error: '' });
    }

    onMemberSearch = (e) => {
        const { value } = e.target;
        this.setState({ memberSearch: value, holder: null });
        if (this.searchTimer) {
            clearTimeout(this.searchTimer);
        }
        if (value.trim().length < 2) {
            this.setState({ members: [] });
            return;
        }
        this.searchTimer = setTimeout(async () => {
            const response = await util.fetchApi('/api/ammosales/members', { method: 'GET' }, { search: value.trim() });
            if (response?.status === 200) {
                this.setState({ members: response.data || [] });
            }
        }, 300);
    }

    pickMember = (member) => {
        this.setState({ holder: member, memberSearch: '', members: [] });
    }

    canSave = () => {
        const { isNew } = this.props;
        const { holder, label, isSaving } = this.state;
        if (isSaving || !label.trim()) {
            return false;
        }
        if (isNew && !holder?.id) {
            return false;
        }
        return true;
    }

    save = async () => {
        const { clubKeyStore, appState } = this.props.stores;
        const {
            isNew, clubKey, callback = () => {}, drawerLevel = 1,
        } = this.props;
        const {
            holder, label, keyType, number, note,
        } = this.state;
        if (!this.canSave()) {
            return;
        }
        this.setState({ isSaving: true, error: '' });
        const input = {
            label, keyType, number, note, holder: holder?.id, customer: appState.currentCustomer?.id,
        };
        const response = isNew
            ? await clubKeyStore.addKey(input)
            : await clubKeyStore.updateKey(clubKey.id, input);
        if (response?.status === 201 || response?.status === 202) {
            callback();
            appState.toggleDrawer(false, drawerLevel);
            return;
        }
        this.setState({ isSaving: false, error: response?.message || 'Could not save' });
    }

    render() {
        const { isNew } = this.props;
        const {
            holder, memberSearch, members, label, keyType, number, note, error, isSaving,
        } = this.state;

        return (
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100' style='max-width: 720px; padding-top: 20px; padding-bottom: 100px;'>
                    <div class='px-3'>
                        <h5 class='mb-3'>
                            <i class='fa-duotone fa-key me-2' />
                            {isNew
                                ? <Text id='clubOps.key-drawer-add'>New club key</Text>
                                : <Text id='clubOps.key-drawer-edit'>Edit club key</Text>}
                        </h5>

                        {!!isNew && (
                            <div class='mb-3'>
                                <label class='form-label'><Text id='clubOps.key-drawer-holder'>Holder</Text></label>
                                {holder?.id ? (
                                    <div class='d-flex align-items-center justify-content-between border rounded p-2'>
                                        <strong>{holder.firstname} {holder.lastname}</strong>
                                        <button type='button' class='btn btn-sm btn-outline-secondary rounded-pill' onClick={() => this.setState({ holder: null })}>
                                            <Text id='clubOps.key-drawer-change-holder'>Change</Text>
                                        </button>
                                    </div>
                                ) : (
                                    <div class='position-relative'>
                                        <input
                                            class='form-control'
                                            type='text'
                                            name='memberSearch'
                                            autocomplete='off'
                                            value={memberSearch}
                                            placeholder='Søk etter medlem'
                                            onInput={this.onMemberSearch}
                                        />
                                        {members.length > 0 && (
                                            <div class='list-group position-absolute w-100 shadow' style='z-index: 10;'>
                                                {members.map(member => (
                                                    <button
                                                        key={member.id}
                                                        type='button'
                                                        class='list-group-item list-group-item-action'
                                                        onClick={() => this.pickMember(member)}
                                                    >
                                                        <strong>{member.firstname} {member.lastname}</strong>
                                                    </button>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        )}

                        <div class='mb-3'>
                            <label class='form-label'><Text id='clubOps.key-drawer-label'>Label</Text></label>
                            <input class='form-control' type='text' name='label' value={label} onInput={this.onField} />
                        </div>

                        <div class='row'>
                            <div class='col-6 mb-3'>
                                <label class='form-label'><Text id='clubOps.key-drawer-type'>Key type</Text></label>
                                <select class='form-select' name='keyType' value={keyType} onInput={this.onField}>
                                    {KEY_TYPES.map(t => <option key={t.key} value={t.key}>{t.label}</option>)}
                                </select>
                            </div>
                            <div class='col-6 mb-3'>
                                <label class='form-label'><Text id='clubOps.key-drawer-number'>Number</Text></label>
                                <input class='form-control' type='text' name='number' value={number} onInput={this.onField} />
                            </div>
                        </div>

                        <div class='mb-3'>
                            <label class='form-label'><Text id='clubOps.key-drawer-note'>Note</Text></label>
                            <input class='form-control' type='text' name='note' value={note} onInput={this.onField} />
                        </div>

                        {!!error && <div class='alert alert-danger py-2'>{error}</div>}

                        <div class='d-flex justify-content-end'>
                            <button type='button' class='btn btn-primary rounded-pill' disabled={!this.canSave()} onClick={this.save}>
                                {!!isSaving && <span class='spinner-border spinner-border-sm me-2' />}
                                <i class='fa-solid fa-save me-1' />
                                <Text id='clubOps.key-drawer-save'>Save</Text>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ClubOpsKeyDrawer;
